import { render, staticRenderFns } from "./SimpleLuggageUpload.vue?vue&type=template&id=90e526b6&scoped=true&"
import script from "./SimpleLuggageUpload.vue?vue&type=script&lang=js&"
export * from "./SimpleLuggageUpload.vue?vue&type=script&lang=js&"
import style0 from "./SimpleLuggageUpload.vue?vue&type=style&index=0&id=90e526b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90e526b6",
  null
  
)

export default component.exports